<template>
<div class="modal is-large" :class="{ 'is-active': active }">
    <div class="modal-background"></div>
    <div class="modal-content">
        <div class="custom-modal-box">
            <div v-if="loading" class="loader-container">
                <img src="/loader-dark.svg">
            </div>

            <div v-if="!loading && file">
                <div class="default-settings-title">
                    <span class="account-name">{{ file.name }}</span>
                </div>
                <div class="default-settings-description">
                    Configure how often and for how long Weap.io should create and keep the backups for the schedule <span class="has-text-grey-darker">{{ file.name }}</span>.
                </div>

                <div class="backup">
                    <div class="default-settings-title">
                        <span class="backup-setting-title">Frequency</span>
                        <span class="default-settings-subtitle">Configure how often we should create snapshots for your cloudlet.</span>
                    </div>

                    <div class="columns">
                        <div class="column is-12">
                            <div class="columns">
                                <div class="column is-4">
                                    <div class="field">
                                        <div class="control has-icons-left">
                                            <div class="select is-fullwidth">
                                                <select v-model="frequency" :disabled="updating" name="predefined-schedule">
                                                    <option v-for="frequencyOption in frequencyOptions" :value="frequencyOption.value">{{ frequencyOption.label }}</option>
                                                </select>
                                            </div>
                                            <div class="icon is-left is-custom-icon-left">
                                                <font-awesome-icon icon="history"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="column is-4">
                                    <div class="field">
                                        <div class="control has-icons-left tooltip is-tooltip-multiline" :data-tooltip="scheduleTooltip">
                                            <div class="select is-fullwidth">
                                                <select v-model="schedule" :disabled="updating" name="predefined-schedule">
                                                    <option v-for="scheduleOption in scheduleOptions" :value="scheduleOption.value">{{ scheduleOption.label }}</option>
                                                </select>
                                            </div>
                                            <div class="icon is-left is-custom-icon-left">
                                                <font-awesome-icon icon="clock"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="column is-4">
                                    <div class="field">
                                        <div class="control has-icons-left">
                                            <div class="select is-fullwidth">
                                                <select v-model="timezone" :disabled="updating" name="predefined-schedule">
                                                    <option v-for="timezone in timezones" :value="timezone.value">{{ timezone.label }}</option>
                                                </select>
                                            </div>
                                            <div class="icon is-left is-custom-icon-left">
                                                <font-awesome-icon icon="globe-americas"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="default-settings-title m-top-50">
                        <span class="backup-setting-title">Retention</span>
                        <span class="default-settings-subtitle">Configure how long we should keep the file backups of your server.</span>
                    </div>

                    <div class="columns is-multiline">
                        <!-- <div class="column is-3">
                            <div @click="selectOption('frequency')" class="backup-frequency backup-frequency-selectable" :class="{'backup-frequency-selected': isSelected('frequency'), 'backup-frequency-disabled': updating}">
                                <div class="icon">
                                    <font-awesome-icon icon="history"/>
                                </div>
                                <div class="details">
                                    <div class="detail-label">
                                        Frequency
                                    </div>
                                    <div class="detail-value">
                                        {{ frequencyLabel }}
                                    </div>
                                </diV>
                            </div>
                        </div> -->
                        <div v-if="multipleSnapshotsPerDay" class="column is-3">
                            <div @click="selectOption('frequentlyRetention')" class="backup-retention backup-retention-selectable" :class="{'backup-frequency-selected': isSelected('frequentlyRetention'), 'backup-frequency-disabled': updating}">
                                <div class="icon">
                                    <font-awesome-icon icon="calendar-day"/>
                                </div>
                                <div class="details">
                                    <div class="detail-label">
                                        {{ frequentlyRetentionLabel }}
                                    </div>
                                    <div class="detail-value">
                                        {{ frequentlyBackupsRetentionLabel }}
                                    </div>
                                </diV>
                            </div>
                        </div>
                        <div class="column" :class="{'is-3': multipleSnapshotsPerDay, 'is-4': !multipleSnapshotsPerDay}">
                            <div @click="selectOption('dailyRetention')" class="backup-retention backup-retention-selectable" :class="{'backup-frequency-selected': isSelected('dailyRetention'), 'backup-frequency-disabled': updating}">
                                <div class="icon">
                                    <font-awesome-icon icon="calendar-day"/>
                                </div>
                                <div class="details">
                                    <div class="detail-label">
                                        Daily backups
                                    </div>
                                    <div class="detail-value">
                                        {{ dailyBackupsRetentionLabel }}
                                    </div>
                                </diV>
                            </div>
                        </div>
                        <div class="column" :class="{'is-3': multipleSnapshotsPerDay, 'is-4': !multipleSnapshotsPerDay}">
                            <div @click="selectOption('weeklyRetention')" class="backup-retention backup-retention-selectable" :class="{'backup-frequency-selected': isSelected('weeklyRetention'), 'backup-frequency-disabled': updating}">
                                <div class="icon">
                                    <font-awesome-icon icon="calendar-week"/>
                                </div>
                                <div class="details">
                                    <div class="detail-label">
                                        Weekly backups
                                    </div>
                                    <div class="detail-value">
                                        {{ weeklyBackupsRetentionLabel }}
                                    </div>
                                </diV>
                            </div>
                        </div>
                        <div class="column" :class="{'is-3': multipleSnapshotsPerDay, 'is-4': !multipleSnapshotsPerDay}">
                            <div @click="selectOption('monthlyRetention')" class="backup-retention backup-retention-selectable" :class="{'backup-frequency-selected': isSelected('monthlyRetention'), 'backup-frequency-disabled': updating}">
                                <div class="icon">
                                    <font-awesome-icon icon="calendar"/>
                                </div>
                                <div class="details">
                                    <div class="detail-label">
                                        Monthly backups
                                    </div>
                                    <div class="detail-value">
                                        {{ monthlyBackupsRetentionLabel }}
                                    </div>
                                </diV>
                            </div>
                        </div>

                        <div class="column is-12">
                            <span style="font-size: 13px;">The last {{ selectedRetentionValue }} file backups of type <b>"{{ selectedRetentionLabel }}"</b> will be retained by Weap. Use the buttons below to decrease/increase the amount.</span>
                        </div>

                        <div class="column is-12 has-text-centered" style="margin-bottom: -10px;">
                            <div @click.exact="decreaseSelectedRetention(1)" v-on:click.shift="decreaseSelectedRetention(10)" class="button is-default-custom minus-button tooltip is-tooltip-left" :disabled="updating" data-tooltip="Hold the Shift key to decrease by 10"><font-awesome-icon icon="minus"/></div>
                            <div @click.exact="increaseSelectedRetention(1)" v-on:click.shift="increaseSelectedRetention(10)" class="button is-default-custom plus-button tooltip is-tooltip-right" :disabled="updating" data-tooltip="Hold the Shift key to increase by 10"><font-awesome-icon icon="plus"/></div>
                        </div>


                    </div>
                </div>

                <div class="columns is-multiline m-top-50">
                    <div class="column is-3">
                        <div @click="updateBackupSettings" :class="{ 'is-loading': updating }" :disabled="updating" class="button custom-button-size is-fullwidth is-info">Save</div>
                    </div>
                    <div class="column is-3">
                        <div @click="close" :disabled="updating" class="close-add-monitor-modal button custom-button-size is-fullwidth is-danger">Cancel</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <button @click="close" class="modal-close is-large" aria-label="close"></button>
</div>
</template>

<script>
import Api from '@/api';
import Swal from 'sweetalert2';

export default {
    props: ['fileId'],

    data() {
        return {
            active: false,
            loading: false,
            updating: false,
            file: null,
            selectedOption: 'frequentlyRetention',
            account: null,
            frequency: null,
            schedule: null,
            timezone: 'UTC',
            frequentlyRetention: null,
            dailyRetention: null,
            weeklyRetention: null,
            monthlyRetention: null,
            frequencyOptions: [
                { label: 'Every 5 minutes', value: 0.083},
                { label: 'Every 15 minutes', value: 0.25},
                { label: 'Every 30 minutes', value: 0.5},
                { label: 'Every hour', value: 1},
                { label: 'Every 2 hours', value: 2},
                { label: 'Every 3 hours', value: 3},
                { label: 'Every 4 hours', value: 4},
                { label: 'Every 6 hours', value: 6},
                { label: 'Every 12 hours', value: 12},
                { label: 'Daily', value: 24},
            ],
            scheduleOptions: [
                { label: '00:00', value: '00:00' },
                { label: '01:00', value: '01:00' },
                { label: '02:00', value: '02:00' },
                { label: '03:00', value: '03:00' },
                { label: '04:00', value: '04:00' },
                { label: '05:00', value: '05:00' },
                { label: '06:00', value: '06:00' },
                { label: '07:00', value: '07:00' },
                { label: '08:00', value: '08:00' },
                { label: '09:00', value: '09:00' },
                { label: '10:00', value: '10:00' },
                { label: '11:00', value: '11:00' },
                { label: '12:00', value: '12:00' },
                { label: '13:00', value: '13:00' },
                { label: '14:00', value: '14:00' },
                { label: '15:00', value: '15:00' },
                { label: '16:00', value: '16:00' },
                { label: '17:00', value: '17:00' },
                { label: '18:00', value: '18:00' },
                { label: '19:00', value: '19:00' },
                { label: '20:00', value: '20:00' },
                { label: '21:00', value: '21:00' },
                { label: '22:00', value: '22:00' },
                { label: '23:00', value: '23:00' },
            ],
            timezones: [
                { label: 'UTC', value: 'UTC' },
            ],
        }
    },

    mounted() {
        this.listenEvents();
    },

    methods: {
        close() {
            if (this.loading || this.updating) {
                return;
            }

            this.active = false;
            this.reset();
        },

        listenEvents() {
            var vm = this;
            Event.$on('showBackupSettings', (selectedOption) => {
                vm.active = true;
                if (typeof selectedOption !== 'undefined') {
                    vm.selectedOption = selectedOption;
                }
                vm.getFile();
            });
        },

        getFile() {
            if (this.loading) {
                return;
            }

            this.loading = true;
            let endpoint = 'files/' + this.fileId;

            Api().get(endpoint)
                .then((response) => {
                    this.file = response.data.data;
                    this.frequency = this.file.frequency.hours;
                    this.schedule = this.file.frequency.start_at;
                    this.frequentlyRetention = this.file.retention.frequently;
                    this.dailyRetention = this.file.retention.daily;
                    this.weeklyRetention = this.file.retention.weekly;
                    this.monthlyRetention = this.file.retention.monthly;

                    if (!this.selectedOption) {
                        if (this.frequency >= 24) {
                            this.selectOption('dailyRetention');
                        } else {
                            this.selectOption('frequentlyRetention');
                        }
                    }
                })
                .catch((error) => {

                })
                .finally(() => {
                    this.loading = false;
                });
        },

        updateBackupSettings() {
            if (this.loading || this.updating) {
                return false;
            }

            this.updating = true;

            let endpoint = 'files/' + this.file.id + '/backup-settings';

            Api().put(endpoint, this.updatedBackupSettings)
                .then(response => {
                    Event.$emit('refreshFile', () => {
                        Swal.fire({
                            title: 'Great!',
                            text: 'The backup frequnecy & retention have been updated.',
                            type: 'success',
                        });
                        this.updating = false;
                        this.close();
                    });
                })
                .catch(error => {
                    //
                });
        },

        decreaseSelectedRetention(amount = 1) {
            if (this.updating) {
                return;
            }

            if (this.isSelected('frequentlyRetention') && this.frequentlyRetention > 0) {
                if ((this.frequentlyRetention - amount) < 0) {
                    this.frequentlyRetention = 0;
                } else {
                    this.frequentlyRetention -= amount;
                }
                return;
            }

            if (this.isSelected('dailyRetention') && this.dailyRetention > 0) {
                if ((this.dailyRetention - amount) < 0) {
                    this.dailyRetention = 0;
                } else {
                    this.dailyRetention -= amount;
                }
                return;
            }

            if (this.isSelected('weeklyRetention') && this.weeklyRetention > 0) {
                if ((this.weeklyRetention - amount) < 0) {
                    this.weeklyRetention = 0;
                } else {
                    this.weeklyRetention -= amount;
                }
                return;
            }

            if (this.isSelected('monthlyRetention') && this.monthlyRetention > 0) {
                if ((this.monthlyRetention - amount) < 0) {
                    this.monthlyRetention = 0;
                } else {
                    this.monthlyRetention -= amount;
                }
                return;
            }
        },

        increaseSelectedRetention(amount = 1) {
            if (this.updating) {
                return;
            }

            if (this.isSelected('frequentlyRetention')) {
                this.frequentlyRetention += amount;
                return;
            }

            if (this.isSelected('dailyRetention')) {
                this.dailyRetention += amount;
                return;
            }

            if (this.isSelected('weeklyRetention')) {
                this.weeklyRetention += amount;
                return;
            }

            if (this.isSelected('monthlyRetention')) {
                this.monthlyRetention += amount;
                return;
            }
        },

        isSelected(option) {
            return this.selectedOption === option;
        },

        selectOption(option) {
            if (this.updating) {
                return;
            }
            this.selectedOption = option;
        },

        reset() {
            this.account = null;
            this.selectedOption = null;

            this.frequency = null;
            this.schedule = null;
            this.timezone = 'UTC';

            this.frequentlyRetention = null;
            this.dailyRetention = null;
            this.weeklyRetention = null;
            this.monthlyRetention = null;
        },
    },

    computed: {
        updatedBackupSettings() {
            return {
                frequency: {
                    hours: this.frequency,
                    start_at: this.schedule,
                },

                retention: {
                    frequently: this.frequentlyRetention,
                    daily: this.dailyRetention,
                    weekly: this.weeklyRetention,
                    monthly: this.monthlyRetention,
                },
            };
        },

        getTitle() {
            if (this.account == null) {
                return '...';
            }

            return this.account.data.name + ' (' + this.account.data.provider.name + ')';
        },

        frequencyLabel() {
            if (this.frequency == null) {
                return '';
            }

            if (this.frequency == 24) {
                return 'Once per day';
            }

            if (this.frequency == 168) {
                return 'Once per week';
            }

            if (this.frequency == 0.083) {
                return 'Every 5 minutes';
            }
            
            if (this.frequency == 0.25) {
                return 'Every 15 minutes';
            }
            
            if (this.frequency == 0.5) {
                return 'Every 30 minutes';
            }

            var label = 'Every ' + this.frequency;

            if (this.frequency > 1) {
                label += ' hours';
            } else {
                label += ' hour';
            }

            return label;
        },

        frequentlyBackupsRetentionLabel() {
            if (this.frequentlyRetention == null || this.frequentlyRetention == 0) {
                return 'Not retained';
            }

            return 'Last ' + this.frequentlyRetention;
        },

        dailyBackupsRetentionLabel() {
            if (this.dailyRetention == null || this.dailyRetention == 0) {
                return 'Not retained';
            }

            return 'Last ' + this.dailyRetention;
        },

        weeklyBackupsRetentionLabel() {
            if (this.weeklyRetention == null || this.weeklyRetention == 0) {
                return 'Not retained';
            }

            return 'Last ' + this.weeklyRetention;
        },

        monthlyBackupsRetentionLabel() {
            if (this.monthlyRetention == null || this.monthlyRetention == 0) {
                return 'Not retained';
            }

            return 'Last ' + this.monthlyRetention;
        },

        scheduleTooltip() {
            if (this.frequency >= 24) {
                return 'The snapshot will be created ' + this.frequencyLabel.charAt(0).toLowerCase() + this.frequencyLabel.slice(1) + ' at ' + this.schedule + ' UTC';
            }

            return 'The snapshot will be created ' + this.frequencyLabel.charAt(0).toLowerCase() + this.frequencyLabel.slice(1) + ' starting from ' + this.schedule + ' UTC in the first day.';
        },

        multipleSnapshotsPerDay() {
            return this.frequency < 24;
        },

        selectedRetentionValue() {
            return this[this.selectedOption];
        },

        frequentlyRetentionLabel() {
            for (var i = 0; i < this.frequencyOptions.length; i++) {
                if (this.frequencyOptions[i].value == this.frequency) {
                    return this.frequencyOptions[i].label;
                }
            }

            return null;
        },

        selectedRetentionLabel() {
            if (this.isSelected('frequentlyRetention')) {
                for (var i = 0; i < this.frequencyOptions.length; i++) {
                    if (this.frequencyOptions[i].value == this.frequency) {
                        return this.frequencyOptions[i].label;
                    }
                }
            }

            if (this.isSelected('dailyRetention')) {
                return 'Daily';
            }

            if (this.isSelected('weeklyRetention')) {
                return 'Weekly';
            }

            if (this.isSelected('monthlyRetention')) {
                return 'Monthly';
            }
        },
    },

    watch: {
        account: function (newAccount) {
            if (this.account == null) {
                return;
            }

            this.frequency = this.account.data.default_frequency.hours;
            this.schedule = this.account.data.default_frequency.start_at;

            this.dailyRetention = this.account.data.default_retention.daily;
            this.weeklyRetention = this.account.data.default_retention.weekly;
            this.monthlyRetention = this.account.data.default_retention.monthly;
        },

        frequency(frequency) {
            if (frequency >= 24 && this.isSelected('frequentlyRetention')) {
                this.selectOption('dailyRetention');
            }
        },
    }
}
</script>
